import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

export type Variant =
	| 'default'
	| 'secondary'
	| 'destructive'
	| 'open'
	| 'outline'
const badgeVariants = cva(
	'focus:ring-ring inline-flex min-h-[28px] items-center rounded-full border px-3 py-1 text-sm leading-none font-semibold transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none',
	{
		variants: {
			variant: {
				default:
					'bg-primary text-primary-foreground hover:bg-primary/80 border-transparent',
				secondary:
					'bg-secondary text-secondary-foreground hover:bg-secondary/80 border-transparent',
				destructive:
					'bg-destructive text-destructive-foreground hover:bg-destructive/80 border-transparent',
				open: 'bg-green text-destructive-foreground hover:bg-green/80 border-transparent',
				outline: 'text-foreground',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
)

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	)
}

export { Badge, badgeVariants }
